import Navigation from '../navigation/Navigation';

export default function Header() {

    return (
        <div>
            <Navigation />
        </div >);
};